module.exports = __webpack_public_path__ + "static/main-250-3bf5cf204c41563d50d255be50808f34.png";